import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "../auth.service";
import { DataServiceService } from "../data-service.service";
import { GetHkDateTimeService } from "../helpers/get-hk-date-time.service";
import { Search } from "../model/search";

@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.scss"],
})
export class SearchComponent implements OnInit {
  isLoading = true;
  isSearchCreditAvailable = false;
  creditsAvailable = 0;
  isChineseSearch = false;
  isIndividualSearch = true;
  isInternationalCriminalsSearch = true
  isAdverseMediaSearch = false;
  isAdverseMediaFeatureEnabled = false;
  isAllDBSearch = true;
  isPepSearch = true;
  isHongKongSearch = true;
  isInternationalSearch = true;
  searchResult: any;
  homeSearchType = "";
  newSearch: Search = new Search();

  constructor(
    private router: Router,
    private dataService: DataServiceService,
    private hkDateService: GetHkDateTimeService,
    private authService: AuthService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    // 清除localStorage中的搜索相关数据
    localStorage.removeItem("dd");
    localStorage.removeItem("mm");
    localStorage.removeItem("yyyy");
    localStorage.removeItem("gender");

    this.isAdverseMediaFeatureEnabled =
      this.authService.getCurrentUser()?.isAdverseMediaEnabled === true;
    if (!this.isAdverseMediaFeatureEnabled) {
      this.isAdverseMediaSearch = false;
    }

    this.checkIfSearchCreditAvailable()
      .then(
        () => {
          if (this.isSearchCreditAvailable == true) {
            localStorage.setItem("isChineseSearch", `${this.isChineseSearch}`);
            localStorage.setItem(
              "isIndividualSearch",
              `${this.isIndividualSearch}`
            );
            this.homeSearchType = localStorage.getItem("searchType");
            if (this.homeSearchType == "advance")
              this.newSearch.isQuick = false;
            else this.newSearch.isQuick = true;
          }
          this.isLoading = false;
        },
        (err) => (this.isLoading = false)
      )
      .catch((err) => (this.isLoading = false));
  }

  async checkIfSearchCreditAvailable() {
    const creditInfo = await this.dataService.getCreditInfo();
    this.creditsAvailable = creditInfo && creditInfo.creditsAvailable
      ? creditInfo.creditsAvailable
      : 0;
    this.isSearchCreditAvailable = this.creditsAvailable > 0;
  }

  chineseSearch() {
    this.isChineseSearch = true;
    localStorage.setItem("isChineseSearch", "true");
  }

  englishSearch() {
    this.isChineseSearch = false;
    localStorage.setItem("isChineseSearch", "false");
  }

  individualSearch() {
    this.isIndividualSearch = true;
    localStorage.setItem("isIndividualSearch", "true");
  }

  entitySearch() {
    this.isIndividualSearch = false;
    this.isChineseSearch = false;
    this.newSearch.isQuick = true;
    localStorage.setItem("isIndividualSearch", "false");
  }

  toggleAllDBSearch() {
    this.isAllDBSearch = !this.isAllDBSearch;
    this.isPepSearch = this.isAllDBSearch;
    this.isHongKongSearch = this.isAllDBSearch;
    this.isInternationalSearch = this.isAllDBSearch;
    this.isInternationalCriminalsSearch = this.isAllDBSearch;
  }

  togglePepSearch() {
    this.isPepSearch = !this.isPepSearch;
    if (!this.isPepSearch) this.isAllDBSearch = false;
  }

  toggleHongKongSearch() {
    this.isHongKongSearch = !this.isHongKongSearch;
    if (!this.isHongKongSearch) this.isAllDBSearch = false;
  }

  toggleInternationalSearch() {
    this.isInternationalSearch = !this.isInternationalSearch;
    if (!this.isInternationalSearch) this.isAllDBSearch = false;
  }

  toggleInternationalCriminalsSearch() {
    this.isInternationalCriminalsSearch = !this.isInternationalCriminalsSearch;
    if (!this.isInternationalCriminalsSearch) this.isAllDBSearch = false;
    console.log('toggleInternationalCriminalsSearch', this.isInternationalCriminalsSearch);
  }

  toggleAdverseMediaSearch() {
    this.isAdverseMediaSearch = !this.isAdverseMediaSearch;
  }

  willSearchAdverseMedia() {
    return this.isAdverseMediaFeatureEnabled && this.isAdverseMediaSearch;
  }

  onSearch(amCreditModal) {
    if (this.willSearchAdverseMedia()) {
      if (this.creditsAvailable < 2) {
        alert(
          "You need at least 2 search credits to enable Adversary Media Search."
        );
        return;
      }
      this.modalService
        .open(amCreditModal, { centered: true, size: "md" })
        .result.then(
          (result) => {
            if (result === "ok") this.proceedSearch();
          },
          () => {}
        );
      return;
    }
    this.proceedSearch();
  }

  toggleAdvanceSearch() {
    this.englishSearch();
    this.newSearch.isQuick = !this.newSearch.isQuick;
    if (this.newSearch.isQuick) localStorage.setItem("searchType", "quick");
    else localStorage.setItem("searchType", "advance");
  }

  invalidQuickForm() {
    if (this.invalidName()) {
      return true;
    } else {
      return false;
    }
  }

  invalidAdvanceForm() {
    if (this.invalidName() || this.invalidYear()) {
      return true;
    } else {
      return false;
    }
  }

  invalidYear() {
    if (
      parseInt(this.newSearch.mm) < 0 ||
      parseInt(this.newSearch.mm) > 12 ||
      parseInt(this.newSearch.dd) < 0 ||
      parseInt(this.newSearch.dd) > 31 ||
      (this.newSearch.yyyy + "").trim() == "" ||
      this.newSearch.yyyy == undefined ||
      this.newSearch.yyyy == null ||
      this.newSearch.yyyy.length < 4
    )
      return true;
    else return false;
  }

  invalidName() {
    if (this.newSearch.englishName.trim() == "") return true;
    else return false;
  }

  proceedSearch() {
    // Check if input contains Chinese characters
    const containsChinese = /[\u4e00-\u9fa5]/.test(this.newSearch.englishName);
    if (containsChinese) {
      this.chineseSearch();
    } else {
      this.englishSearch();
    }

    localStorage.setItem(
      "searchDateAndTime",
      this.hkDateService.getHKDateAndTime()
    );
    localStorage.setItem("isAllDBSearch", this.isAllDBSearch + "");
    localStorage.setItem("isPepSearch", this.isPepSearch + "");
    localStorage.setItem("isHongKongSearch", this.isHongKongSearch + "");
    localStorage.setItem(
      "isInternationalSearch",
      this.isInternationalSearch + ""
    );
    localStorage.setItem(
      "isAdverseMediaSearch",
      this.willSearchAdverseMedia() + ""
    );
    
    if (this.isChineseSearch)
      localStorage.setItem("chinese_string", this.newSearch.englishName);
    if (this.newSearch.isQuick)
      this.router.navigate(["/searchlist", this.newSearch.englishName]);
    else {
      if (
        this.newSearch.dd == null ||
        this.newSearch.dd == undefined ||
        this.newSearch.dd == ""
      )
        this.newSearch.dd = "00";
      if (
        this.newSearch.mm == null ||
        this.newSearch.mm == undefined ||
        this.newSearch.mm == ""
      )
        this.newSearch.mm = "00";
      if (
        this.newSearch.yyyy == null ||
        this.newSearch.yyyy == undefined ||
        this.newSearch.yyyy == ""
      )
        this.newSearch.yyyy = "0000";

      localStorage.setItem("dd", this.newSearch.dd);
      localStorage.setItem("mm", this.newSearch.mm);
      localStorage.setItem("yyyy", this.newSearch.yyyy);
      localStorage.setItem("gender", this.newSearch.gender);
      this.router.navigate(["/searchlist", this.newSearch.englishName]);
    }
  }
}
